

document.addEventListener("DOMContentLoaded", function () {
  try {
    // Your script code goes here
    new Splide(".text-item-carousel-section .splide", {
      type: "loop",
      autoWidth: true,
      drag: false,
      //focus: "center",
      gap: "0.6rem",
      perPage: 35,
      pagination: false,
      //arrows: true,
      autoScroll: { speed: 0.5,pauseOnHover: false },
      classes: {
        arrows: "splide__arrows custom-arrows",
        arrow: "splide__arrow",
        prev: "splide__arrow--prev custom-arrow-previous",
        next: "splide__arrow--next custom-arrow-next"
      }
    }).mount(window.splide.Extensions);
    // If an error occurs, it will be caught by the catch block
  } catch (error) {
    console.error("Splide Error: " + error);
  }
});
